var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"oct-icon",class:("oct-icon__" + _vm.icon),attrs:{"viewBox":("0 0 " + _vm.width + " " + _vm.height)}},[_c('use',{attrs:{"xlink:href":("#oct-icon__" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }